import cn from 'classnames';
import type { FC } from 'react';

import Link from '@/components/_rebrand/Link';
import { Text } from '@/components/_rebrand/Text';

import Icon from '../Icon';
import Logo, { type LogoProps } from '../Logo';
import { TextCombination } from '../TextCombination';

export type TestimonialCardProps = {
  logo: LogoProps['type'];
  quote: string;
  authorName: string;
  authorTitle: string;
  href: string;
  className?: string;
};

export const TestimonialCard: FC<TestimonialCardProps> = ({
  logo,
  quote,
  authorName,
  authorTitle,
  href,
  className
}) => {
  return (
    <Link href={href} className={cn(
      'group !overflow-visible flex flex-col rounded-8',
      'focus-visible:outline focus-visible:outline-citron-500 focus-visible:outline-[3px]',
      className)}>
      <div className={cn(
        'flex flex-col flex-1 rounded-8 border border-l0 p-px',
        'transition-[box-shadow,transform] duration-600 ease-in-out',
        'group-hover:surface-l1 group-hover:shadow-quote-card sm:group-hover:-translate-y-[12px]'
      )}>
        <div className={cn(
          'surface-l0 flex flex-col flex-1 gap-2xs rounded-[7px] min-w-s pt-2xs pb-lg px-lg',
          'transition-colors duration-600 ease-in-out',
          'group-hover:surface-l1'
        )}>
          <div className="h-8 flex items-center justify-between gap-xs">
            <Logo type={logo} isFullColor={true} />
            <span className={cn(
              'surface-l1 group-hover:surface-l1-active rounded-full p-xs',
              'transition-colors duration-600 ease-in-out'
            )}>
              <Icon name="arrow-narrow-up-right" size={16} className="text-primary" />
            </span>
          </div>
          <div className="flex flex-col gap-xl">
            <Text type="h4" as="h4" className="text-primary">{quote}</Text>
            <div className="flex flex-col gap-4xs">
              <TextCombination
                type="p2"
                className="text-primary"
                title={authorName}
                description={authorTitle}
                align="left"
              />
            </div>
          </div>
        </div>
      </div>
    </Link>
  )
};
